<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersApi from "@/services/users-api";
import CustomerApi from "@/services/customers-api";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
  return null;
}

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Profil",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout},
  mounted(){
    this.getLogin()
    this.getCustomerInfo()

  },
  data() {
    return {
      login:'',
      oldPassword:'',
      newPassword:'',
      confirmationPassword:'',
      customerInfo:{
        invoiceAddressMail: null,
        invoiceTaxRefNumber: null,
      },
    activeTab: 'change-password',
    };
  },
  created() {
    if (this.isNewProfileUi && this.role == 0 && this.showCustomerInfo) {
      this.activeTab = 'billing-info';
    }
  },

  computed: {
    role() {
      return this.$cookies.get('userr');
    },

    showCustomerInfo() {
      return process.env.VUE_APP_FEATURE_CUSTOMER_INFO === 'true';
    },
    permission() {
      const  storedPermissions = JSON.parse(getCookie('permission')) || [];
      return storedPermissions
    },
    isNewProfileUi() {
      return process.env.VUE_APP_FEATURE_NEW_PROFILE_UI === "true";
    },
    userFullName() {
      return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
    },
  },

  methods: {
    getCustomerInfo(){
      CustomerApi.getCustomerInfo().then(
        result => {
          this.customerInfo=result
        }
      )
    },
    saveCustomerProfile(){
      CustomerApi.saveCustomerProfile(this.customerInfo).then(
        result => {
          if (result) {
            this.customerInfo=result
          }
        }
      )
    },

    getLogin(){
      UsersApi.getLogin().then(
        result => {
          this.login=result
        }
      )
    },

    ChangePassword() {
      UsersApi.ChangePassword(this.oldPassword, this.newPassword, this.confirmationPassword)
      .then(
        result => {
          if (result) {
            this.oldPassword = '';
            this.newPassword = '';
            this.confirmationPassword = '';
          }
        }
      )
    },

    setActiveTab(tab) {
        this.activeTab = tab;

        if (window.innerWidth < 768) {
          this.$nextTick(() => {
            const content = document.getElementById(tab + '-content');
            if (content) {
              content.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
      },
  },
};
</script>
<template>
  <Layout>
    <div class="row pt-4 p-sm-4">

      <div class="col-md-3 col-12 border-md-right" v-if="isNewProfileUi" >
        <div class="rounded-3 mr-md-2 mr-0 pt-2 mb-2 mb-md-0">

          <div class=" border-0 px-3 pt-3 mb-4">
            <h5 class="text-dark mb-0 text-center text-uppercase">Profil de {{this.userFullName}}</h5>
          </div>
          <div class=" p-0">
            <ul class="nav flex-column nav-pills profile-nav">
              <li class="nav-item" v-if="role == 0  && showCustomerInfo">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'billing-info' }"
                  href="#"
                  @click.prevent="setActiveTab('billing-info')"
                >
                  Informations de facturation
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  :class="{ active: activeTab === 'change-password' }"
                  href="#"
                  @click.prevent="setActiveTab('change-password')"
                >
                  Modification du mot de passe
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <!-- Main content -->
      <div :class="isNewProfileUi ? 'col-md-9 col-12 mt-2 mt-md-0' : 'col-12'" class="h-100">
        <!-- Billing Info -->
        <div
          v-if="activeTab === 'billing-info' && role == 0 && showCustomerInfo"
          class="card border ml-md-2 ml-0" id="billing-info-content"
        >
          <div class="card-body">
            <h4 class="card-title pt-2 pb-4 text-dark font-size-18">
              {{ $t("profil.infoTitle") }}
            </h4>
            <form>
              <div class="mb-3 row">
                <label class="col-md-3 col-form-label" for="invoiceMailAddress">
                  {{ $t("profil.invoiceMailAddress") }}
                </label>
                <div class="col-md-9">
                  <input
                    id="invoiceMailAddress"
                    v-model="customerInfo.invoiceAddressMail"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-md-3 col-form-label" for="taxRef">
                  {{ $t("profil.taxRef") }}
                </label>
                <div class="col-md-9">
                  <input
                    id="taxRef"
                    v-model="customerInfo.invoiceTaxRefNumber"
                    class="form-control"
                    autocomplete="off"
                  />
                </div>
              </div>
            </form>

            <div class="text-right mt-3">
              <small class="text-danger d-block mb-2">
                Seul l'administrateur de l'officine est habilité à effectuer cette action
              </small>
              <button
                class="btn btn-danger"
                @click="saveCustomerProfile"
                :disabled="!permission.includes('CUSTOMER_ADMIN')"
              >
                {{ $t("buttons.save") }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'change-password' || !showCustomerInfo " class="card border ml-md-2 ml-0"  id="change-password-content">
          <div class="card-body">
            <h4 class="card-title pt-2 pb-4 text-dark font-size-18 ">{{$t('profil.passwordTitle')}}</h4>
                <div class="row">
                  <b-form class="col-12">
                    <div class="form-group row mb-3">
                        <label class="col-md-3 col-form-label" for="name" >{{$t('profil.user')}}</label>
                <div class="col-md-9">
                  <input type="text" name="login" class="form-control" style="background-color: #f0f3ec;" v-model="login" disabled/>
                </div>
              </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">{{$t('profil.oldPassword')}}</label>
                <div class="col-md-9">
                  <input 
                          id="Oldpwd"
                  type="password" 
                  v-model="oldPassword" 
                  class="form-control"
                  autocomplete="off"
                   />
                </div>
              </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="pwd">{{$t('profil.newPassword')}}</label>
                <div class="col-md-9">
                  <input 
                          id="Newpwd"
                  type="password" 
                  v-model="newPassword" 
                  class="form-control" 
                  autocomplete="off"
                  />
                </div>
              </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="confirmpwd">{{$t('profil.confirmationPassword')}}</label>
                <div class="col-md-9">
                  <input 
                          id="confirmpwd"
                  type="password"
                  v-model="confirmationPassword"
                          class="form-control"
                          autocomplete="off"
                        />
                      </div>
                    </div>
                    <div class="row mt-4 mb-0" style="float: right; text-align: right;">
                      <b-button  class="ml-2 " variant="danger" style="display: inline-block" @click="ChangePassword()" >
                        <span class="text-white font-weight-bold">{{$t('buttons.save')}}</span>
                      </b-button>
                    </div>                    
                  </b-form>
                  <!-- end col -->
                </div>
                <!-- end row -->
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>


<style>

.profile-nav .nav-link {
  border-radius: 0.5rem;
  font-size: 0.8rem;
  padding: 0.75rem 1rem;
  color: #74788d;

  i {
    font-size: 1rem;
  }

  &.active {
    background-color: #ddd !important;
    color: inherit !important;
    font-weight: bold !important;
  }
}

@media (min-width: 768px) {
  .border-md-right {
    border-right: 1px solid #ddd;
  }
}

</style>